
import { Component, OnInit, HostBinding, HostListener, Input, ElementRef, OnDestroy } from '@angular/core';

 
@Component({
  selector: 'bi-popup-menu',
  templateUrl: './bi-popup-menu.component.html',
  styleUrls: ['./bi-popup-menu.component.scss']
})

export class BIPopupMenuComponent implements OnInit , OnDestroy{
  @HostBinding("style.top") y = "0px"
  @HostBinding("style.left") x = "0px"
  @HostBinding("style.visibility") visibility = "hidden"
  @Input() @HostBinding("style.width") width = "200px"
 
  constructor(private elRef: ElementRef) {
   
   }
  visible:boolean=false;
  ngOnInit() {
  }
 
  open(e:MouseEvent) {
   // this.x = `${e.offsetX}px`
    //this.y = `${e.offsetY}px`
    

    const collection = Array.from(document.getElementsByClassName("bi-popup-menu") as HTMLCollectionOf<HTMLElement>);
     for (let i = 0; i < collection.length; i++) {
              
         collection[i].style.visibility = 'hidden';
     }
     
     /*this.visibility = "hidden" */
    

    var rect = this.elRef.nativeElement.getBoundingClientRect(); 
     // x= x+ rect.left;
      //y=y+ rect.top;
    

    const x = e.clientX-rect.left+this.elRef.nativeElement.offsetLeft ;
    const y = e.clientY-rect.top+this.elRef.nativeElement.offsetTop;


    this.x = `${x}px`
    this.y = `${y}px`
    
    this.visibility = "visible"
    this.elRef.nativeElement.style.visibility="visible"
    e.stopPropagation();
  //  e.stopPropagation()
  
    
  }
 
  close() {
    this.visibility = "hidden"
  }

  
 
  @HostListener('document:click')
  public onDocumentClick() {
    if (this.visibility === "visible") {
      this.close()
    }
  }

  @HostListener('document:contextmenu')
  public onDocumentRClick(event:_Event) {
     if (this.visibility === "visible") {
      this.close()
    }
  }

  ngOnDestroy(): void {
    this.visibility= "hidden"
 }


}